import React, { createContext, useState, useEffect } from 'react';
import { useQuery, gql, useApolloClient } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

// Création du contexte
const AuthContext = createContext();

// Query GraphQL pour récupérer l'utilisateur courant
const ME_QUERY = gql`
  query Me {
    me {
      id
      username
      email
      firstName
      lastName
      role
      department {
        id
        name
      }
    }
  }
`;

// Provider du contexte d'authentification
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');
  const client = useApolloClient();
  const navigate = useNavigate();

  const { data, refetch } = useQuery(ME_QUERY, {
    skip: !token,
    onCompleted: (data) => {
      if (data && data.me) {
        setUser(data.me);
      }
      setLoading(false);
    },
    onError: (error) => {
      console.error("Erreur lors de la récupération de l'utilisateur:", error);
      // Si l'erreur est due à un problème d'authentification, supprimer le token
      if (
        error.message.includes('authentification') ||
        error.message.includes('authentication') ||
        error.message.includes('Signature has expired') ||
        error.message.includes('expired') ||
        error.message.includes('token')
      ) {
        localStorage.removeItem('token');
        setUser(null);
      }
      setLoading(false);
    }
  });

  useEffect(() => {
    if (!token) {
      setLoading(false);
    }
  }, [token]);

  const login = (token, callback) => {
    localStorage.setItem('token', token);
    refetch().then(() => {
      if (callback) callback();
    });
  };

  const logout = (callback) => {
    // Supprimer le token du localStorage
    localStorage.removeItem('token');
    
    // Réinitialiser l'état de l'utilisateur
    setUser(null);
    
    // Réinitialiser le cache Apollo
    client.resetStore().catch(error => {
      console.error("Erreur lors de la réinitialisation du cache:", error);
    });
    
    // Rediriger vers la page de connexion
    navigate('/login');
    
    // Appeler le callback si fourni
    if (callback) callback();
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated: !!user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Export du contexte
export { AuthContext };
export default AuthContext; 
